module.exports = __webpack_public_path__ + "images/lucky-7-12469685c042a2bd7f88d885f9b86a09.png";